import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { ShareComponent } from '@sh/components/share/share.component';

type RiveCanvasModule = typeof import('@rive-app/webgl2');
type RiveCanvasRuntime = RiveCanvasModule & { default?: RiveCanvasModule };

@Component({
  selector: 'app-get-involved',
  templateUrl: './get-involved.component.html',
  styleUrls: ['./get-involved.component.scss'],
  imports: [ShareComponent],
  standalone: true,
})
export class GetInvolvedComponent implements OnInit, OnDestroy {
  @ViewChild('riveCanvas') canvasRef!: ElementRef<HTMLCanvasElement>;
  private riveCanvas: HTMLCanvasElement;
  private riveInstance: any;
  private riveModule: RiveCanvasModule | null = null;
  private destroyed = false;

  ngOnInit() {}

  async ngAfterViewInit() {
    if (!this.canvasRef || !this.canvasRef.nativeElement) return;
    const rive = await this.loadRive();
    if (this.destroyed) return;
    this.riveCanvas = this.canvasRef.nativeElement;

    this.riveInstance = new rive.Rive({
      src: 'assets/rive/info_card.riv',
      canvas: this.riveCanvas as HTMLCanvasElement,
      autoplay: true,
      artboard: 'Artboard',
      stateMachine: 'State Machine 1',
      automaticallyHandleEvents: true,

      onLoad: () => {
        this.riveInstance.resizeDrawingSurfaceToCanvas();
      },
    });
  }

  private async loadRive() {
    if (!this.riveModule) {
      const riveModule = (await import(
        '@rive-app/webgl2'
      )) as RiveCanvasRuntime;
      this.riveModule = riveModule.default ?? riveModule;
      this.riveModule.RuntimeLoader.setWasmUrl(
        new URL('assets/rive/rive.wasm', document.baseURI).href,
      );
      this.riveModule.RuntimeLoader.setWasmFallbackUrl(
        new URL('assets/rive/rive_fallback.wasm', document.baseURI).href,
      );
    }

    return this.riveModule;
  }

  ngOnDestroy() {
    this.destroyed = true;
    this.riveInstance?.cleanup();
  }
}
